/**
 * Constants for Energy Flow chart components
 *
 * These constants define the styling and layout values for tooltips
 * and other chart-related UI elements.
 */

/**
 * Default chart dimensions used across Energy Flow components
 */
export const CHART_DIMENSIONS = {
  /** Default chart width in pixels */
  WIDTH: 648,
  /** Default chart height in pixels */
  HEIGHT: 400,
} as const;

/**
 * Tooltip configuration constants for CustomTooltip component
 */
export const TOOLTIP = {
  /** Height of each text line in the tooltip (pixels) */
  LINE_HEIGHT: 18,
  /** Number of data lines displayed in the tooltip */
  LINE_COUNT: 5,
  /** Internal padding of the flyout box (pixels) */
  PADDING: 12,
  /** Width of the flyout box (pixels) */
  FLYOUT_WIDTH: 200,
  /** Font size for tooltip text (pixels) */
  FONT_SIZE: 14,
  /** Border radius for the flyout box corners (pixels) */
  BORDER_RADIUS: 2,
  /** Stroke width for flyout border (pixels) */
  STROKE_WIDTH: 1,
} as const;

/**
 * Tooltip positioning constants used by tooltipPositionUtils
 */
export const TOOLTIP_POSITION = {
  /** Minimum margin from chart edges (pixels) */
  CHART_MARGIN: 10,
  /** Gap between the data point and the flyout box (pixels) */
  FLYOUT_GAP: 10,
  /** Length of the pointer triangle (pixels) */
  POINTER_LENGTH: 4,
  /** Half-width of the pointer triangle base (pixels) */
  POINTER_HALF_WIDTH: 5,
} as const;

/**
 * Calculate the total height of the tooltip flyout
 */
export const calculateFlyoutHeight = (): number => {
  return TOOLTIP.LINE_HEIGHT * TOOLTIP.LINE_COUNT + TOOLTIP.PADDING * 2;
};
